import api from './api';

/**
 * Requests Service
 * Handles all request management API calls
 */
const requestsService = {
    /**
     * Get all requests with pagination and filters
     * @param {Object} params - Query parameters
     * @returns {Promise<Object>}
     */
    getAll: async (params = {}) => {
        const queryString = new URLSearchParams(params).toString();
        return api.get(`/admin/requests${queryString ? `?${queryString}` : ''}`);
    },

    /**
     * Get request by ID
     * @param {string} id - Request ID
     * @returns {Promise<Object>}
     */
    getById: async (id) => {
        return api.get(`/admin/requests/${id}`);
    },

    /**
     * Update request status
     * @param {string} id - Request ID
     * @param {string} status - New status
     * @returns {Promise<Object>}
     */
    updateStatus: async (id, status) => {
        return api.patch(`/admin/requests/${id}/status`, { status });
    },

    /**
     * Delete request
     * @param {string} id - Request ID
     * @returns {Promise<Object>}
     */
    delete: async (id) => {
        return api.delete(`/admin/requests/${id}`);
    },

    /**
     * Export requests data
     * @param {Object} params - Query parameters
     * @returns {Promise<Object>}
     */
    export: async (params = {}) => {
        const queryString = new URLSearchParams(params).toString();
        return api.get(`/admin/requests/export${queryString ? `?${queryString}` : ''}`);
    }
};

export default requestsService;
